import { render, staticRenderFns } from "./PProgress.vue?vue&type=template&id=9a81107a"
import script from "./PProgress.vue?vue&type=script&lang=js"
export * from "./PProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports